/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Dtp_Bulk_SuccessInputs */

const vi_dtp_bulk_success = /** @type {(inputs: Dtp_Bulk_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã tạo ${i?.count} phiếu cân chè khô`)
};

/**

* @param {Dtp_Bulk_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dtp_bulk_success = /** @type {((inputs: Dtp_Bulk_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dtp_Bulk_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dtp_bulk_success(inputs)
});